import $, { data } from 'jquery';
import axios from 'axios';

export const quoteFormSelects = () => {
    $('.form__select--deadline').select2({
        minimumResultsForSearch: -1,
        dropdownCssClass: "form__dropdown",
    });

    $('.form__select--budget').select2({
        minimumResultsForSearch: -1,
        dropdownCssClass: "form__dropdown",
    });

    // Labels
    const formGroups = $('.form__group--select');

    $(formGroups).each(function(index, group) {
        const formLabel = $(group).find('.form__label');
        const selectContainer = $(group).find('.select2-container');

        if (($(group).find('.select2-selection__rendered').html()?.length ?? 0) > 0) {
            $(group).addClass('form__group--active');
            $(formLabel).addClass('form__label--active');
        }

        $(selectContainer).on('focusin', function() {
            $(group).addClass('form__group--active');
            $(formLabel).addClass('form__label--active');
        });

        $(selectContainer).on('focusout', function() {
            if (($(group).find('.select2-selection__rendered').html()?.length ?? 0) < 1) {
                $(group).removeClass('form__group--active');
                $(formLabel).removeClass('form__label--active');
            }
        });
    });
};

export const quoteFormValidation = () => {
    let errorInvalidEmail = '';

    if (typeof errorInvalidEmailMessage !== "undefined") {
        errorInvalidEmail = errorInvalidEmailMessage;
    }

    $.validator.addMethod("customEmail",
        function(value, element) {
            return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
        },
        errorInvalidEmail
    );

    const quoteForm = document.querySelector('.form--quote');

    if (quoteForm) {
        $(".form--quote").validate({
            rules: {
                'quote_request_form[name]': {
                    required: true,
                    minlength: 3,
                },
                'quote_request_form[email]': {
                    required: true,
                    customEmail: true,
                },
                'quote_request_form[projectDescription]': {
                    required: true,
                    minlength: 3
                },
                'quote_request_form[privacyPolicy]': {
                    required: true,
                },
            },
            messages: {
                'quote_request_form[name]': {
                    required: 'This field is required',
                    minlength: 'This field must contain at least 3 characters',
                },
                'quote_request_form[email]': {
                    required: 'This field is required',
                    email: 'Email address is not in valid format',
                    customEmail: 'Email address is not in valid format',
                },
                'quote_request_form[projectDescription]': {
                    required: 'This field is required',
                    minlength: 'This field must contain at least 3 characters'
                },
                'quote_request_form[privacyPolicy]': {
                    required: 'To submit a form, you need to agree with our Privacy Policy first.',
                },
            },
            errorElement: 'div',
            errorClass: 'form__error',
            errorPlacement: function(error, element) {
                error.appendTo(element.parent());
            },
            submitHandler: function(form, event) {
                if ($(form).valid()) {
                    sendQuoteForm(event);
                }
                return false;
            },
        }).settings.ignore = [];
    }
};

const sendQuoteForm = (event) => {
    event.preventDefault();

    const formElement = $('.form--quote');

    sendRequest().then(response => {
        console.log(response)
        if(response.data.status === 'fail') {
            //HANDLE ERRORS
            if (response.data.data.message) {
                $(formElement).find('.js-form-error').append('<div class="form__message form__message--error">' + response.data.data.message + '</div>');
            }
        } else {
            if (response.data.data) {
                location.href = response.data.data.redirect_uri;
                $(formElement)[0].reset();
            }
        }
    }).catch(error => {
        $(formElement).find('.js-form-error').append('<div class="form__message form__message--error">' + error + '</div>');
    });
};

function sendRequest() {
    const formElement = $('.form--quote');
    const payload = new FormData(formElement[0]);

    return new Promise((resolve, reject) => {
        axios.post('/contact/quote-request', payload).then((response) => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};
